import React from 'react';
import { SEOHead } from '../components/SEOHead';
import { TopBanner } from '../components/TopBanner';
import { MainBookHero } from '../components/MainBookHero';
import { MobileCarousel } from '../components/MobileCarousel';
import { TransformationSlider } from '../components/TransformationSlider';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ContentPreview } from '../components/ContentPreview';
import { ResultsSection } from '../components/ResultsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ExpertEndorsement } from '../components/ExpertEndorsement';
import { BundleOfferSection } from '../components/BundleOfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <>
      {/* SEO Optimization for all search engines */}
      <SEOHead data-id="element-681" />

      <div className="min-h-screen bg-black text-white selection:bg-gold-500 selection:text-black" lang="es" data-id="element-682">
        {/* Sticky top banner */}
        <TopBanner data-id="element-683" />

        {/* Main content with semantic HTML */}
        <main data-id="element-684">
          {/* PARTE 1: PROMOCIÓN DEL EBOOK PRINCIPAL */}
          <MainBookHero data-id="element-685" />
          <TransformationSlider data-id="element-686" />
          <ProblemSection data-id="element-687" />
          <SolutionSection data-id="element-688" />
          <ContentPreview data-id="element-689" />
          <ResultsSection data-id="element-690" />
          <TestimonialsSection data-id="element-691" />
          <ExpertEndorsement data-id="element-692" />

          {/* Mobile-only carousel - Luxury compact design */}
          <MobileCarousel data-id="element-693" />

          {/* PARTE 2: OFERTA DEL PACK COMPLETO (7 EBOOKS) */}
          <BundleOfferSection data-id="element-694" />

          <GuaranteeSection data-id="element-695" />
          <FAQSection data-id="element-696" />
          <FinalCTA data-id="element-697" />
        </main>

        {/* Footer with semantic HTML */}
        <Footer data-id="element-698" />
      </div>
    </>;
}